<script>
    import { _ } from 'svelte-i18n';
    import { url } from '../stores/url.js';
    import { roles } from '../stores/roles.js';
    import axios from 'axios';
    import { request } from '../functions/http-helpers.js';
    import { tableSort, swalConfirm } from '../functions/html-helpers.js';
    import { onMount } from 'svelte';
    import UIkit from 'uikit';

    let bv_new_role = '';
    let bv_search = '';
    let bv_edit_role_name = '';
    let bv_edit_role_id = '';
    let keyup_search_timeout = null; 
    $: filteredRoles = filterRoles($roles, bv_search);


    /* SETUP */
    onMount(() => {
        setTimeout(() => {
            tableSort();
        }, 500);
    });


    /* HTML inserts */
    function filterRoles() { 
        return $roles.filter(p => p.name.includes(bv_search));
    }



    /* Events */
    function setRoleBinds(r) {
        bv_edit_role_id = r.id;
        bv_edit_role_name = r.name;
    }




    /* POST */
	async function saveRole() {
        const [ data, error ] = await request('post', `${$url}/role/create`, {
            name: bv_new_role
        });
        if(!error) {
            bv_new_role = '';
            $roles = [...$roles, data]; 
        }
	}



    /* UPDATE */  
    async function updateRole() {
        const [ data, error ] = await request('put', `${$url}/role/update/${bv_edit_role_id}`, {
            name: bv_edit_role_name
        });
        if(!error) {
            UIkit.modal('#m_edit_role').hide();
            filtered_roles.find(r => r.id == bv_edit_role_id).name = bv_edit_role_name;
            filtered_roles = filtered_roles;
            $roles = filtered_roles;
        }
    }



    /* DELETE */
    async function removeRole(id) {
        const confirmed = await swalConfirm('Benutzerrolle entfernen', 'Soll die Benutzerrolle wirklich entfernt werden?', 'warning', $_('yes'));
        if(confirmed) {
            const [ data, error ] = await request('delete', `${$url}/role/remove/${id}`);
            if(!error) {
                filtered_roles = filtered_roles.filter(t => t.id != id);
                $roles = filtered_roles;
            }
        }        
	}

</script>


<div class="uk-container">
    <div class="uk-card uk-card-default uk-card-body uk-margin-top">
        <h3>{$_('user_roles')}</h3>

        {#if !$roles.length}
            <div class="uk-alert" uk-alert>
                Keine Benutzerrollen angelegt
            </div>
        {:else}
            <input type="text" class="uk-input" placeholder="{$_('search')}..." bind:value={bv_search} />
            <table class="uk-table uk-table-striped uk-table-small">
                <thead>
                    <tr>
                        <th>
                            <span class="th-sort-icon" uk-icon=""></span>
                            {$_('name')}
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {#each filteredRoles as role}
                        <tr>
                            <td data-sort={role.name}>
                                {role.name}
                            </td>
                            <td class="uk-text-right">
                                <span class="uk-margin-small-right c-pointer" uk-icon="pencil" uk-toggle="target: #m_edit_role" on:click={() => setRoleBinds(role)}></span>
                                <span class="uk-text-danger c-pointer" uk-icon="trash" on:click={() => removeRole(role.id)}></span>
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
        {/if}
        

        <div uk-grid>
            <div class="uk-width-2-3@m">
                <input type="text" placeholder="{$_('new-role')}" class="uk-input" bind:value={bv_new_role} on:keyup={e => e.key==='Enter' && saveRole()} />
            </div>
            <div class="uk-width-1-3@m">
                <button class="uk-button uk-button-primary uk-float-right" on:click={() => saveRole()}>{$_('save')}</button>
            </div>
        </div>

        <!-- Modals -->
        <div id="m_edit_role" uk-modal>
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">{$_('edit-role')}</h2>
                </div>
                <div class="uk-modal-body">
                    <div uk-grid>
                        <div class="uk-width-1-1">
                            <label>{$_('name')}: <span class="uk-text-danger">*</span></label>
                            <input type="text" class="uk-input" bind:value={bv_edit_role_name} />
                        </div>
                    </div>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-default uk-modal-close uk-margin-small-right uk-width-auto@s uk-width-1-1" type="button">{$_('cancel')}</button>
                    <button class="uk-button uk-button-primary uk-width-auto@s uk-width-1-1" on:click={() => updateRole()}>{$_('save')}</button>
                </div>
            </div>
        </div>
    </div>
</div>